<template>
  <div>
    <a-card title="短信模版列表">
     <a-button slot="extra" type="primary" @click="addTemplate">新增</a-button>
     <!-- 搜索框 -->
      <a-form layout="inline" @submit="handleSubmit" :form="form">
          <a-form-item>
            <a-form-item label="模版">
                <a-input  v-model="searchP.keyword"  placeholder="模版名称/编码" ></a-input>
            </a-form-item>

             <a-form-item label="模版内容">
                <a-input  v-model="searchP.templatetext"  placeholder="模版内容" ></a-input>
            </a-form-item>

           <a-form-item label="是否是oem类短信">
              <a-select v-model="searchP.needoem"  placeholder="" style="width:100px;">
                    <a-select-option value=""> 全部  </a-select-option>
                    <a-select-option key="0">否</a-select-option>
                    <a-select-option key="1">是</a-select-option>
                </a-select>
           </a-form-item>

           <a-form-item label="短信模板类型">
              <a-select v-model="searchP.templatetype"  placeholder="" style="width:100px;">
                    <a-select-option key="">全部</a-select-option>
                    <a-select-option key="1">验证码</a-select-option>
                    <a-select-option key="2">通知短信</a-select-option>
                    <a-select-option key="3">推广短信</a-select-option>
                </a-select>
           </a-form-item>

            <a-form-model-item  label="开始日期" prop="starttime">
                 <a-date-picker v-model="searchP.starttime" format="YYYY-MM-DD" />
            </a-form-model-item>

            <a-form-model-item  label="结束日期" prop="endtime">
                <a-date-picker  v-model="searchP.endtime"   format="YYYY-MM-DD" />
            </a-form-model-item>

            <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
        </a-form-item>

          <a-form-item>
            <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
             </a-button>
          </a-form-item>

      </a-form>
    </a-card>

    <!-- 短信签名列表 -->
    <a-table :columns="columns" :data-source="data" :scroll="{ x: 800}"  :pagination="false" :loading="tLoading" rowKey="id" >
         <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
         <span>
            <router-link
                    :to="{
                    path:'detailTemplate',
                    query: {
                        id: record.id
                    }
                }"
                >编辑</router-link>
          </span>
          <span>
            <a-popconfirm title="确认删除?" @confirm="() => deleteTemplate(record)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
     
  </div>
</template>
<script>
import { mapState } from "vuex";
const data = [];

let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 100,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },{
        title: "短信模板编码",
        dataIndex: "templatecode",
        width:350
    },
    {
        title: "短信模板名称",
        dataIndex: "templatename",
        width:300
    },
    {
        title: "短信模板内容",
        dataIndex: "templatetext",
        width:600,
    },
    {
        title: "是否是oem类短信",
        dataIndex: "needoemname",
        width:250
    },
    {
        title: "短信模板类型",
        dataIndex: "templatetypename",
        width:200
    },
    {
        title: "短信模签名",
        dataIndex: "signname",
        width:200
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        width:300
    },
   
    {
        title: "创建人",
        dataIndex: "createuser",
        width:200
    },
   
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 150,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            },
            record: this.$route.query || {},
        
        };
    },
    methods: {

        handlePageChange(c_p){
            this.getSmsTemplateList(c_p)
        },

        // 查询短信模版列表
        getSmsTemplateList(cpage){
            let c_params = {
                ...this.searchP
            }
            c_params.endtime = c_params.endtime ?  this.dateFormat('YYYY-mm-dd',new Date(c_params.endtime)) : '';
            c_params.starttime =c_params.starttime ? this.dateFormat('YYYY-mm-dd',new Date(c_params.starttime)): '';
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "smsmanager/queryTemplatePageList",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },

        handleSearchReset(){
            this.$store.dispatch({
                type: "smsmanager/getEmptySearch",
                showMsg: true
            })
        },

        handleSubmit(e){
            e.preventDefault();
            this.getSmsTemplateList(1);

        },

        //新增签名
        addTemplate(){
            this.$router.push({
                path: "addTemplate",
                query: {id:''}
            });
        },

        // 删除签名
        deleteTemplate(key) {
            this.$store.dispatch({
                type: "smsmanager/deleteTemplate",
                params: {...key}
            }).then((res) => {
                
                if(res.status == '200'){
                    this.getSmsTemplateList();
                }
            });
        },

        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },

    },
    computed:{
        ...mapState('smsmanager', {
            searchP: state => state.searchP,
        })
    },

    mounted(){
        this.getSmsTemplateList(1);
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
